import React, { useContext } from 'react';
import { SessionConsumptionConsolidatedRow } from '../styles';
import { ConsolidatedCard } from '../../components/Metrics/ConsolidatedCard';
import SessionConsumptionContext from '../../../../contexts/SessionConsumptionContext';

const RenderCard = ({
  title,
  value,
  currentMonth,
  consolidatedContainsDataOnSelectedMonth,
  content,
  tooltipText,
  margin,
}: any) => (
  <bds-grid {...(margin && { margin })}>
    <ConsolidatedCard
      title={title}
      value={value}
      currentMonth={currentMonth}
      consolidatedContainsDataOnSelectedMonth={consolidatedContainsDataOnSelectedMonth}
      content={content}
      tooltipText={tooltipText}
    />
  </bds-grid>
);

const RenderConsolidatedCardsComponent = () => {
  const {
    currentMonth,
    compiledSessionConsumptionDataState,
    oldCompiledSessionConsumptionDataState,
    content,
    showConsolidatedSessionNewPricing,
  } = useContext(SessionConsumptionContext);

  const oldData = oldCompiledSessionConsumptionDataState.oldConsolidatedSessionConsumption;
  const oldHasData = oldCompiledSessionConsumptionDataState.oldConsolidatedContainsDataOnSelectedMonth;

  const {
    consolidatedSessionConsumption: {
      allConversations,
      billedConversations,
      freeOfChargeConversations,
    },
    consolidatedContainsDataOnSelectedMonth: hasNewData,
  } = compiledSessionConsumptionDataState;

  const newCategories = [
    {
      title: content.consolidated.conversationTypeCategory.newPricing.all.title,
      title_detail: content.consolidated.conversationTypeCategory.newPricing.all.title_detail,
      subTitle: content.consolidated.conversationTypeCategory.newPricing.subTitle,
      data: [
        { label: content.consolidated.conversationTypeCategory.newPricing.marketing, value: allConversations.marketing },
        { label: content.consolidated.conversationTypeCategory.newPricing.marketing_lite, value: allConversations.marketing_lite },
        { label: content.consolidated.conversationTypeCategory.newPricing.utility, value: allConversations.utility },
        { label: content.consolidated.conversationTypeCategory.newPricing.authentication, value: allConversations.authentication },
        { label: content.consolidated.conversationTypeCategory.newPricing.service, value: allConversations.service },
      ],
      oldPricing: {
        title: content.consolidated.conversationTypeCategory.oldPricing.title,
        sessions: [
          { label: content.consolidated.conversationTypeCategory.oldPricing.sessionsByCompany, value: allConversations.oldWhatsappPricing?.sessionByCompany },
          { label: content.consolidated.conversationTypeCategory.oldPricing.sessionsByUser, value: allConversations.oldWhatsappPricing?.sessionByUser },
        ],
      },
      margin: 'r-3',
    },
    {
      title: content.consolidated.conversationTypeCategory.newPricing.regular.title,
      title_detail: content.consolidated.conversationTypeCategory.newPricing.regular.title_detail,
      subTitle: content.consolidated.conversationTypeCategory.newPricing.subTitle,
      data: [
        { label: content.consolidated.conversationTypeCategory.newPricing.marketing, value: billedConversations.marketing },
        { label: content.consolidated.conversationTypeCategory.newPricing.marketing_lite, value: billedConversations.marketing_lite },
        { label: content.consolidated.conversationTypeCategory.newPricing.utility, value: billedConversations.utility },
        { label: content.consolidated.conversationTypeCategory.newPricing.authentication, value: billedConversations.authentication },
        { label: content.consolidated.conversationTypeCategory.newPricing.service, value: billedConversations.service },
      ],
      oldPricing: {
        title: content.consolidated.conversationTypeCategory.oldPricing.title,
        sessions: [
          { label: content.consolidated.conversationTypeCategory.oldPricing.sessionsByCompany, value: billedConversations.oldWhatsappPricing?.sessionByCompany },
          { label: content.consolidated.conversationTypeCategory.oldPricing.sessionsByUser, value: billedConversations.oldWhatsappPricing?.sessionByUser },
        ],
      },
    },
    {
      title: content.consolidated.conversationTypeCategory.newPricing.free.title,
      title_detail: content.consolidated.conversationTypeCategory.newPricing.free.title_detail,
      data: [
        {
          label: content.consolidated.conversationTypeCategory.newPricing.free.freeEntryPoint,
          value: freeOfChargeConversations.freeEntryPoint,
        },
        {
          label: content.consolidated.conversationTypeCategory.newPricing.free.freeCustomerService,
          value: freeOfChargeConversations.freeCustomerService,
        },
      ],
      margin: 'l-3',
    },
  ];

  return (
    <SessionConsumptionConsolidatedRow>
      <bds-grid
        class="main-session-grid"
        xs="12"
        gap="3"
        direction="column"
        flexWrap="wrap"
        justify-content="center"
      >
        {!showConsolidatedSessionNewPricing && (
          <bds-grid
            class="old-session-grid"
            xs="12"
            direction="row"
            justify-content="space-between"
          >
            <RenderCard
              title={content.consolidated.sessionsByUser}
              value={oldData.sessionByUser}
              currentMonth={currentMonth}
              consolidatedContainsDataOnSelectedMonth={oldHasData}
              content={content}
              margin="r-3"
            />
            <RenderCard
              title={content.consolidated.sessionsByCompany}
              value={oldData.sessionByCompany}
              currentMonth={currentMonth}
              consolidatedContainsDataOnSelectedMonth={oldHasData}
              content={content}
            />
            <RenderCard
              title={content.consolidated.sessionsTotal}
              value={oldData.sessionTotal}
              currentMonth={currentMonth}
              consolidatedContainsDataOnSelectedMonth={oldHasData}
              content={content}
              margin="l-3"
            />
          </bds-grid>
        )}

        {showConsolidatedSessionNewPricing && (
          <>
            <bds-grid
              class="new-session-grid"
              xs="12"
              direction="row"
              justify-content="space-between"
            >
              <RenderCard
                title={newCategories[0].title}
                value={allConversations.total}
                currentMonth={currentMonth}
                consolidatedContainsDataOnSelectedMonth={hasNewData}
                content={content}
                margin="r-3"
              />
              <RenderCard
                title={newCategories[1].title}
                value={billedConversations.total}
                currentMonth={currentMonth}
                consolidatedContainsDataOnSelectedMonth={hasNewData}
                content={content}
              />
              <RenderCard
                title={newCategories[2].title}
                value={freeOfChargeConversations.total}
                currentMonth={currentMonth}
                consolidatedContainsDataOnSelectedMonth={hasNewData}
                content={content}
                margin="l-3"
              />
            </bds-grid>

            <bds-grid
              class="category-session-grid"
              xxs="12"
              direction="row"
              justify-content="space-between"
            >
              {newCategories.map((category) => (
                <bds-grid
                  key={category.title_detail}
                  class="bg-color-surface-2"
                  direction="column"
                  margin={category.margin as any}
                >
                  <bds-typo variant="fs-16" bold="bold" margin class="b-1">
                    {category.title_detail}
                  </bds-typo>
                  {category.subTitle && (
                    <bds-typo class="color-content-disable" variant="fs-14">
                      {category.subTitle}
                    </bds-typo>
                  )}
                  {category.data.map((item) => (
                    <bds-grid key={item.label} direction="row" justify-content="space-between">
                      <bds-grid direction="row" justify-content="flex-start">
                        <bds-typo variant="fs-14">{item.label}</bds-typo>
                      </bds-grid>
                      <bds-typo variant="fs-14">
                        {hasNewData ? item.value?.toLocaleString(content.locale) : '--'}
                      </bds-typo>
                    </bds-grid>
                  ))}
                  {category.oldPricing && (
                    <>
                      <bds-typo
                        variant="fs-14"
                        class={
                          category.oldPricing.sessions.some((s) => s.value)
                            ? 'color-content-disable'
                            : 'none'
                        }
                      >
                        {category.oldPricing.title}
                      </bds-typo>
                      {category.oldPricing.sessions.map((session) => (
                        <bds-grid
                          key={session.label}
                          direction="row"
                          justify-content="space-between"
                          class={session.value ? '' : 'none'}
                        >
                          <bds-typo variant="fs-14">{session.label}</bds-typo>
                          <bds-typo variant="fs-14">
                            {hasNewData && session.value
                              ? session.value.toLocaleString(content.locale)
                              : '--'}
                          </bds-typo>
                        </bds-grid>
                      ))}
                    </>
                  )}
                </bds-grid>
              ))}
            </bds-grid>
          </>
        )}
      </bds-grid>
    </SessionConsumptionConsolidatedRow>
  );
};

export default RenderConsolidatedCardsComponent;
